import React from "react";
import "./DigiHero.css"; // Import CSS for styling

const FutureHero= () => {
  return (
    <div className="digihero-container">
      <img
        src="assets/schemes/future.png"
        alt="Digi Hero"
        className="digihero-image"
      />
    </div>
  );
};

export default FutureHero;
